uniform sampler2D uHeightMap;
uniform vec3 uColorOne;
uniform vec3 uColorTwo;
uniform float uLightIntensity;

varying vec2 vUv;

void main() {

  float variation = texture2D(uHeightMap, vUv).r;

  vec3 colorOne = uColorOne;
  vec3 colorTwo = uColorTwo;
  
  vec3 color = mix(colorOne, colorTwo, 1.0 - variation) * uLightIntensity;

  gl_FragColor = vec4(color, 1.0);
}